export enum AccountScreen {
    Login = 'login',
    ForgotUser = 'forgotUser',
    SecurityQuestion = 'securityQuestion',
    SecurityAnswer = 'securityAnswer',
    CreatePassword = 'createPassword',
    Activation = 'activation',
    Policy = 'policy',
}

export const ACCOUNT_SCREEN_PATHS = {
    [AccountScreen.Login]: '/',
    [AccountScreen.ForgotUser]: '/forgotUser',
    [AccountScreen.SecurityQuestion]: '/securityQuestions',
    [AccountScreen.SecurityAnswer]: '/securityQuestions/securityAnswers',
    [AccountScreen.CreatePassword]: '/createPassword',
    [AccountScreen.Activation]: '/activateUser',
    [AccountScreen.Policy]: '/policy',
} as const satisfies Record<AccountScreen, string>;

export const POLICY_PATH = ACCOUNT_SCREEN_PATHS[AccountScreen.Policy];
